import { View, Text } from 'react-native'
import React from 'react'

export default function Skeleton() {
  return (
    <View style={{ flex: 1, height: '100%', width: '100%' }}>
      
    </View>
  )
}